import React from 'react';

// MUI
import { TreeItem, TreeItemProps, useTreeItemModel } from '@mui/x-tree-view';

export type PPTreeItemType = {
  itemId: string;
  id: string;
  label: string;
  isClanak: boolean;
  isContent: boolean
};

const PPTreeItem = React.forwardRef((
  props: TreeItemProps,
  ref: React.Ref<HTMLLIElement>,
) => {
  const item = useTreeItemModel<PPTreeItemType>(props.itemId)!;

  return (
    <TreeItem
      {...props}
      ref={ref}
      sx={{
        fontStyle: item.isClanak ? "italic" : "normal"
        // textAlign: item.isContent ? "justify" : "center"
      }}
      slotProps={{
        iconContainer: {
          style: { display: item.isContent ? 'none' : 'inherit'}
        },
      //   content: {
      //     style: { paddingLeft: item.isContent ? 1 : undefined}
      //   }
      }}
    />
  );
});

export default PPTreeItem;